import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizzesSelectors';
// Components
import Accordion from 'components/Accordion';
import CallToActionForm from './CallToActionForm';

type Props = {
  defaultExpanded?: boolean;
}

const CallToAction:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const isSurveyQuiz = quiz && quiz.type === QuizTypes.Survey;
  const isPollQuizzes = quiz && [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isSurveyOrPollQuizzes = isSurveyQuiz || isPollQuizzes;

  if ( quiz && [QuizTypes.Personality].includes(quiz.type) ) return null;
  return (
    <div react-scroll="callToAction">
      <Accordion
        label={isSurveyOrPollQuizzes ? t('pages.quizForm.postQuizPageLabel') : t('pages.quizForm.callToActionLabel')}
        icon="call_to_action"
        previewPage="post-quiz"
        defaultExpanded={defaultExpanded}
      >
        <CallToActionForm />
      </Accordion>
    </div>
  )
}

export default CallToAction;
